import { wymhTickerTitles } from "@/mocks/wymh-content";

export default function WymhTicker() {
  const items = [...wymhTickerTitles, ...wymhTickerTitles];

  return (
    <div className="w-full bg-foreground-950 border-y border-background-50/10 overflow-hidden py-4">
      <div className="wymh-marquee-track">
        {items.map((title, index) => (
          <span
            key={`${title}-${index}`}
            className="shrink-0 inline-flex items-center gap-2 px-6 text-sm text-background-100/75 whitespace-nowrap"
          >
            <i className="ri-radio-button-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
            {title}
          </span>
        ))}
      </div>
    </div>
  );
}